import { render, staticRenderFns } from "./DetailMain.vue?vue&type=template&id=a54dabec&scoped=true"
import script from "./DetailMain.vue?vue&type=script&lang=js"
export * from "./DetailMain.vue?vue&type=script&lang=js"
import style0 from "./DetailMain.vue?vue&type=style&index=0&id=a54dabec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54dabec",
  null
  
)

export default component.exports